import { Component, EventEmitter, Output, Input } from '@angular/core';
import {Common} from '../../shared/common';
import {ShortVoter} from '../../models/ShortVoter';

@Component({
  selector: 'resent-invite-popup',
  templateUrl: './resent-invite-popup.component.html',
  styleUrls: ['./resent-invite-popup.component.less', '../../shared/common.less']
})
export class ResentInvitePopupComponent {
  @Output() endDetailsPopup = new EventEmitter<boolean>();
  @Input() contactInvited: string = "";
  @Input() messageAttached: string = "";

  constructor(public common: Common) {}

  onDismiss(event: boolean) {
    this.endDetailsPopup.emit(event);
  }

  ngOnInit() {}
}
